import { render, staticRenderFns } from "./ordersView.vue?vue&type=template&id=484c261d&scoped=true"
import script from "./ordersView.vue?vue&type=script&lang=js"
export * from "./ordersView.vue?vue&type=script&lang=js"
import style0 from "./ordersView.vue?vue&type=style&index=0&id=484c261d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c261d",
  null
  
)

export default component.exports